export function initHeader() {

    const header = document.querySelector('.main-header');
    const nav = document.querySelector('.upgraded__main-menu');

    if (!header || !nav) return;

    /* Sticky header: the utility bar above scrolls away first, then the header
       pins. Flag .is-stuck once we've scrolled past the utility bar so CSS can
       add a shadow / solid backing. On mobile the utility bar is hidden
       (offsetHeight 0), so the header pins as soon as the page scrolls. */
    const utilityBar = document.querySelector('.header-utility');
    let stickyOffset = 0;
    function measure() {
        stickyOffset = utilityBar ? utilityBar.offsetHeight : 0;
    }
    function updateStuck() {
        header.classList.toggle('is-stuck', window.scrollY > stickyOffset);
    }
    measure();
    updateStuck();
    window.addEventListener('scroll', updateStuck, { passive: true });
    window.addEventListener('resize', function () { measure(); updateStuck(); }, { passive: true });

    /* Hamburger-menu */
    const toggle = document.querySelector('.menu-toggle');
    if (toggle) {
        toggle.addEventListener('click', function () {
            const isOpen = nav.classList.toggle('is-open');
            toggle.classList.toggle('is-open', isOpen);
            toggle.setAttribute('aria-expanded', isOpen);
        });
    }

    /* Dropdown arrow buttons */
    document.querySelectorAll('.upgraded__main-menu .menu-item-has-children').forEach(function (li) {

        const btn = document.createElement('button');
        btn.className = 'dropdown-toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Toggle submenu');
        btn.innerHTML = '<svg width="24" height="24" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06z" clip-rule="evenodd"/></svg>';

        const link = li.querySelector(':scope > a');
        if (link) {
            link.insertAdjacentElement('afterend', btn);

            /* Parent items act as dropdown triggers, not links: clicking the
               label opens/closes the submenu just like the arrow button. */
            link.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                toggleItem(li);
            });
        }

        btn.addEventListener('click', function (e) {
            e.stopPropagation();
            toggleItem(li);
        });
    });

    /**
     * External links
     * If the URL link differs from the current site. Using an external link.
     * */
    document.querySelectorAll('.upgraded__main-menu li.portal a').forEach(function (a) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');

        // Append right-arrow icon
        const arrow = document.createElement('span');
        arrow.className = 'external-arrow';
        arrow.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
        a.appendChild(arrow);
    });

    /* Close menu when clicked outside. */
    document.addEventListener('click', closeMenu);
    document.addEventListener('touchend', closeMenu);

    function closeMenu(e) {
        if (!nav.contains(e.target)) closeAll();
    }

    function openItem(li) {
        li.parentElement.querySelectorAll(':scope > .menu-item-has-children.is-open').forEach(function (sib) {
            if (sib !== li) closeItem(sib);
        });
        li.classList.add('is-open');
        const btn = li.querySelector(':scope > .dropdown-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    function closeItem(li) {
        li.classList.remove('is-open');
        const btn = li.querySelector(':scope > .dropdown-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        li.querySelectorAll('.is-open').forEach(function (child) {
            child.classList.remove('is-open');
        });
    }

    function toggleItem(li) {
        li.classList.contains('is-open') ? closeItem(li) : openItem(li);
    }

    function closeAll() {
        document.querySelectorAll('.upgraded__main-menu .is-open').forEach(function (el) {
            el.classList.remove('is-open');
            const btn = el.querySelector(':scope > .dropdown-toggle');
            if (btn) btn.setAttribute('aria-expanded', 'false');
        });
    }

}

/**
 * Audience switcher
 * Remembers the last audience choice (consultant / client) in localStorage and
 * reflects it as the active option. Visiting an audience page updates the stored
 * choice; clicking an option persists it before navigation.
 */
export function initAudienceSwitcher() {

    const STORAGE_KEY = 'upgraded_audience';
    const ACTIVE_CLASSES = ['bg-blue', 'text-white'];
    const INACTIVE_CLASSES = ['bg-white', 'text-black'];

    // There can be more than one switcher in the DOM (utility bar on desktop,
    // mobile nav panel) — collect the options from all of them so they stay in sync.
    const switchers = document.querySelectorAll('.audience-switcher');
    if (!switchers.length) return;

    const options = Array.prototype.slice.call(document.querySelectorAll('.audience-switcher .audience-option'));
    if (!options.length) return;

    const logo = document.querySelector('.audience-logo');

    function store(audience) {
        try { localStorage.setItem(STORAGE_KEY, audience); } catch (e) {}
    }

    function read() {
        try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    }

    // Highlight the option matching the given audience, clearing the others.
    function setActive(audience) {
        // Keep the <html> attribute (set pre-paint by the head guard) in sync.
        document.documentElement.setAttribute('data-audience', audience);
        options.forEach(function (option) {
            const isActive = option.getAttribute('data-audience') === audience;
            option.classList.remove.apply(option.classList, isActive ? INACTIVE_CLASSES : ACTIVE_CLASSES);
            option.classList.add.apply(option.classList, isActive ? ACTIVE_CLASSES : INACTIVE_CLASSES);
            if (isActive) {
                option.setAttribute('aria-current', 'page');
            } else {
                option.removeAttribute('aria-current');
            }
        });

        // Point the logo at the selected audience's landing page.
        const active = options.find(function (option) {
            return option.getAttribute('data-audience') === audience;
        });
        const url = active && active.getAttribute('href');
        if (logo && url && url !== '#') {
            logo.setAttribute('href', url);
        }
    }

    // Persist the audience only when the current page is a specific audience
    // section. The consultant landing is the (language) home — e.g. "/en" —
    // which prefixes every page in that language; treating that as a match would
    // overwrite the remembered choice on every page. So we ignore any option
    // whose path is an ancestor of another option's path (the broad/home
    // default), and among the rest the most specific match wins.
    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

    const optionPaths = options.map(function (option) {
        const href = option.getAttribute('href');
        if (!href || href === '#') return null;
        try { return new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/'; }
        catch (e) { return null; }
    });

    // True when another audience lives beneath this path (so it's the home/parent).
    function isBroadDefault(path) {
        return optionPaths.some(function (other) {
            return other && other !== path && other.indexOf(path + '/') === 0;
        });
    }

    let matched = null;
    options.forEach(function (option, i) {
        const optionPath = optionPaths[i];
        if (!optionPath || optionPath === '/' || isBroadDefault(optionPath)) return;
        const isMatch = currentPath === optionPath || currentPath.indexOf(optionPath + '/') === 0;
        if (isMatch && (!matched || optionPath.length > matched.path.length)) {
            matched = { option: option, path: optionPath };
        }
    });

    if (matched) {
        store(matched.option.getAttribute('data-audience'));
    }

    // Reflect the remembered choice (page visit takes precedence, then stored value).
    const remembered = read();
    if (remembered) {
        setActive(remembered);
    }

    // Persist the choice as soon as the user picks one.
    options.forEach(function (option) {
        option.addEventListener('click', function () {
            store(option.getAttribute('data-audience'));
        });
    });

}
